import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as QRCode from 'qrcode';
import { addYears, format } from 'date-fns';
import { SharedService } from 'src/app/services/shared.service';
import { getApplicantDetails, getUserProfile } from 'src/app/store/selectors/account.selector';
import { AppState } from 'src/app/store/app.state';
import { getShowBackFront } from 'src/app/store/selectors/shared.selector';

@Component({
  selector: 'app-view-id',
  templateUrl: './view-id.component.html',
  styleUrls: ['./view-id.component.scss']
})
export class ViewIdComponent implements OnInit {

  getUserProfile$: Observable<any>;
  userProfile: any;

  getApplicantDetails$: Observable<any>;
  applicantDetails: any;

  getShowBackFront$: Observable<any>;
  showBackFront: any;

  ngUnsubscribe = new Subject<void>();

  disabilities: string = 'N/A';
  profilePic: string | null = null;
  signature: string | null = null;
  qrCode: SafeHtml = '';

  isShowFront = true;

  userQr: any;

  userAvatar: any;

  sectionShow = 1;

  constructor(
    private cdr: ChangeDetectorRef,
    private dom: DomSanitizer,
    private sharedService: SharedService,
    private sanitizer: DomSanitizer,
    private store: Store<AppState>
    
  ) { 
    this.getUserProfile$ = this.store.select(getUserProfile);
    this.getApplicantDetails$ = this.store.select(getApplicantDetails);
    this.getShowBackFront$ = this.store.select(getShowBackFront);
   }

  ngOnInit() {
    this.getUserProfile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.userProfile = res;
      }
    });

    this.getApplicantDetails$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (res) => {
      if(res){        
        const allowedStatuses = ['verified'];

        const filteredDemographics = res.demographic.filter((d: any) =>
          allowedStatuses.includes(d.status)
        );
        this.applicantDetails = {
          ...res,
          demographic: filteredDemographics
        };
        const svg = await QRCode.toString(JSON.stringify(this.applicantDetails?.qrcode), {type: 'svg', margin: 0});
        this.qrCode = this.sanitizer.bypassSecurityTrustHtml(svg);
      }
    });

    this.getShowBackFront$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.sectionShow = res;
      }
    });
  }
  
  getMiddleInitial(name: string): string {
    return name && name.trim().length > 0
      ? name.trim().charAt(0).toUpperCase() + '.'
      : '';
  }

  formatBday(date){
    if (!date) return '';

    const [year, month, day] = date.split('-').map(Number);
    const localDate = new Date(year, month - 1, day);
    return format(localDate, 'MMM d, yyyy');
  }

  getDateIssued(date){
    if(date){
      date = format(new Date(date), 'MM/dd/yyyy');
    }

    return date;
  }

  getExpiration(date) {
    if (date) {
      const newDate = addYears(new Date(date), 5);
      return format(newDate, 'MM/dd/yyyy');
    }
    return date;
  }

  get getLguContent(){
    const getOrganization = this.applicantDetails?.organizations?.find((e) => e?.orgType == 'LGU');
    if(getOrganization){
      return getOrganization
    } else{
      const getOrganization = this.applicantDetails?.scp_org;
      return getOrganization
    }
  }

  get getDisabilityType(){
    const typesString = this.applicantDetails?.demographic?.filter((e) => e?.code == 'PWD' && (e?.status !== 'canceled' || e?.status !== 'expired'))
      ?.map(d => d.type)
      .join(', ');

      return typesString
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  async toBase64Image(url: string): Promise<string> {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  get profilePicture(){
    return this.applicantDetails?.documents?.find((e) => e?.type?.docName == 'Profile Picture')?.docUrl
  }
}
